import { StackScreenProps } from "@react-navigation/stack";
import {
  Page,
  TextField,
  Button,
  useFlashMessages,
} from "@towersystems/roam-common-native";
import { useCallback, useEffect, useState } from "react";
import { View } from "react-native-ui-lib";
import { ActionsRootParamList } from "../../../../types";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import {
  useParkSale,
  useSaleControllerProvider,
} from "../../utils/sale-controller/hooks";
import { useActionBackOrClose } from "../../utils/use-action-back-or-close";
import React from "react";

export type ParkScreenProps = StackScreenProps<
  ActionsRootParamList,
  "ParkScreen"
>;

export const ParkScreen = ({ navigation }: ParkScreenProps) => {
  const { sale } = useSaleControllerProvider();
  const { showMessage } = useFlashMessages();
  const [value, setValue] = useState(sale?.note || "");
  useActionBackOrClose(navigation);
  const parkSale = useParkSale();
  const shouldFocus = useHasTransitionEnded(navigation);

  const handleOnPark = useCallback(async () => {
    parkSale(value)
      .then(() => navigation.getParent()?.goBack())
      .catch((err) => {
        showMessage({
          message: err.message,
          severity: "error",
        });
      });
  }, [value, parkSale]);

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label="Park Sale"
          isAction
          onPress={() => handleOnPark()}
          size="compact"
        ></Button>
      ),
    });
  }, [handleOnPark]);

  return (
    <Page scrollable={false}>
      <View style={{ height: "100%" }} flex>
        <TextField
          textarea
          placeholder="Leave a note..."
          value={value}
          onChangeText={(v) => setValue(v)}
          autoFocus={shouldFocus}
          selectTextOnFocus
        />
      </View>
    </Page>
  );
};
